<template>
  <!-- read Coupon -->
  <van-overlay
    v-on="$listeners"
    v-bind="$attrs"
    :lock-scroll="false"
    get-container="body"
  >
    <div class="wrapper" @click.stop>
      <div class="newCouponMain">
        <h3>
          Si tiene problemas con el cupón, comuníquese con el servicio de
          atención al cliente.
        </h3>

        <div class="couponBox">
          <div v-for="item in couponList">
            <!-- 左侧金额/天数/折扣文案展示 -->
            <div
              class="leftTitle"
              :style="{
                color: couponColor[item.couponType],
                background: couponBgcColor[item.couponType],
              }"
            >
              <div style="display: flex;align-items: baseline;">
                <span v-show="item.couponType == 1">-</span>
                {{ item.couponAmount }}
                <span style="font-size: 0.3rem;margin-left: 0.03rem;">
                  {{ couponAmountText[item.couponType] }}
                </span>
              </div>
            </div>
            <!-- 右侧详情文案/时间展示 -->
            <div class="rightContent">
              <h5>{{ couponName[item.couponType] }}</h5>
              <h3>{{ couponDesc[item.couponType] }}</h3>
              <p>
                Vencimiento: {{ $setMoment(item.effectiveDate, 1) }} -
                {{ $setMoment(item.expireDate, 1) }}
              </p>
            </div>
          </div>
        </div>

        <div class="footBtnBox">
          <div @click="closeVisible" class="closeBtn">
            Confirmar
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { readCoupon } from "../utils/api/h5page.js";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      // 优惠券参数
      couponList: [],
      couponBgcColor: {
        1: "#FFEFEF", // 减免券背景颜色
        4: "#E4EFFF", // 提额券背景颜色
        5: "#E6FFF2", // 延期券背景颜色
        6: "#FFF1E6", // 折扣券背景颜色
      },
      couponColor: {
        1: "#D23D34", // 减免券字体颜色
        4: "#4244B7", // 提额券字体颜色
        5: "#2AAC76", // 延期券字体颜色
        6: "#CB844B", // 折扣券字体颜色
      },
      couponAmountText: {
        1: "", // 减免
        4: "", // 提额
        5: "días", // 延期券
        6: "%", // 折扣券
      },
      couponDesc: {
        1: "Hacer que reduzca la cantidad del préstamo a pagar", // 减免券
        4: "Hacer que obtenga más préstamos", // 提额券
        5: "Permitirle extender el número de días del préstamo", // 延期券
        6: "Puede reducir los intereses de su pedido según el descuento del cupón de descuento", // 折扣券
      },
      couponName: {
        1: "Cupón para reducir el pago", // 减免券
        4: "Cupón de aumento de límite", // 提额券
        5: "Cupón de extensión de plazo", // 延期券
        6: "Cupón de descuento", // 折扣券
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (localStorage.getItem("token")) {
      this.getNewCoupon();
    }
  },
  methods: {
    getNewCoupon() {
      readCoupon({ ui_version: "231109", app_version_code: "10" }).then(
        ({ data }) => {
          console.log("[ data ] >", JSON.parse(data.data));
          this.couponList = JSON.parse(data.data);
          if (this.couponList.length) {
            this.newCouponListVisible = true;
            this.$emit("openVisible");
          }
        }
      );
    },

    closeVisible() {
      this.$emit("closeVisible");
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .newCouponMain {
    position: relative;
    width: 5.66rem;
    height: 8.97rem;
    background: url("../assets/images/newCouponBgc.png") no-repeat;
    background-size: 100% 100%;
    padding-top: 2.38rem;
    & > h3 {
      width: 3.93rem;
      margin: 0 auto 0.25rem;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.18rem;
      color: #666666;
      text-align: center;
    }
    .footBtnBox {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 1.56rem;
      background: url("../assets/images/footBtnBgc.png") no-repeat;
      background-size: 100% 100%;
      .closeBtn {
        cursor: pointer;
        width: 3.7rem;
        height: 0.9rem;
        background: linear-gradient(270deg, #ff4996 0%, #ff914b 100%);
        border-radius: 0.45rem;
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 0.32rem;
        color: #ffffff;
        text-align: center;
        line-height: 0.9rem;
      }
    }
    .couponBox {
      position: relative;
      padding: 0 0.33rem;
      height: 4.31rem;
      overflow: scroll;
      padding-bottom: 0.5rem;
      background: transparent;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;

      & > div {
        position: relative;
        display: flex;
        width: 100%;
        height: 1.36rem;
        background: #ffffff;
        border-radius: 0.16rem;
        margin-bottom: 0.2rem;

        .leftTitle {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 1.36rem;
          height: 1.36rem;
          background: #e4efff;
          border-radius: 0.16rem;
          border: 0.02rem solid #ffffff;
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 0.46rem;
          line-height: 0.54rem;
        }

        .rightContent {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 0.15rem;
          h5 {
            font-family: Roboto, Roboto;
            font-weight: 500;
            font-size: 0.18rem;
            color: #333333;
          }
          h3 {
            width: 2.95rem;
            font-family: Roboto, Roboto;
            font-weight: 500;
            font-size: 0.14rem;
            color: #333333;
            margin: 0.1rem 0;
          }
          p {
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 0.14rem;
            color: #999999;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 760px) {
  .wrapper {
    .newCouponMain {
      width: 5.36rem;
      height: 8.81rem;
    }
  }
}

.van-overlay {
  z-index: 999;
}
</style>
